var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _vm.type === 'select' ? _c('el-select', _vm._g(_vm._b({
    attrs: {
      "value": _vm.$attrs.value || '',
      "filterable": "",
      "clearable": ""
    }
  }, 'el-select', _vm.$attrs, false), _vm.$listeners), [_vm.renderOptions ? _vm._l(_vm.renderOptions, function (item) {
    return _c('el-option', {
      key: item[_vm.valueKey],
      attrs: {
        "value": item[_vm.valueKey],
        "label": item[_vm.labelKey]
      }
    });
  }) : _vm._e()], 2) : _c('tag-list', _vm._g({
    attrs: {
      "value": _vm.$attrs.value || '',
      "controls": _vm.renderOptions,
      "label-key": _vm.labelKey,
      "value-key": _vm.valueKey
    }
  }, _vm.$listeners));
};

var staticRenderFns = [];
export { render, staticRenderFns };